import Header from "../menu/Header";
import Menu from "../menu/Menu";
import logoMobile from "../../../assets/logoa2.png";
import toast from "react-hot-toast";
import { sendTicket } from "../../../services/kojaServices";
import Swal from 'sweetalert2'
// import 'sweetalert2/src/sweetalert2.scss'

const ExpertSupport = () => {

  const sendMessage = async () => {
    try {
        const title = document.getElementById("title").value;
        const content = document.getElementById("content").value;
        if (title && content) {
          let sendData = {
            title,
            content,
          };
          Swal.fire({
            title: 'لطفا منتظر بمانید',
            didOpen: () => { Swal.showLoading() },
          })
          const { data } = await sendTicket(sendData);
          let text = data.result_message
          Swal.close()
          Swal.fire({
            icon: 'success',
            title: `${text}`,
            showConfirmButton: false,
            timer: 2000
          })
          document.getElementById("title").value = ''
          document.getElementById("content").value = ''
        } else {
          toast.error("عنوان یا متن پیام نمی تواند خالی باشد");
        }
    } catch (err) {
      console.log(err);
      toast.error('درخواست شما نجام نشد لطفا مجددا امتحان کنید');
      Swal.close()
    }
  };

  return (
    <div className=""  style={{paddingTop:"10px"}}>
      <Header />
      <div
        className="d-flex request-box-content"
        style={{ margin: "20px 30px 20px 30px" }}
      >
        <Menu />
        <div className="w-100 text-center m-auto">
          <div className="message-support-box">
            <div className="d-flex align-items-center">
              <img alt="" src={logoMobile} className="message-support-logo" />
              <h3 className="me-3 message-support-header d-none d-md-block">
                ارسال پیام به پشتیبانی
              </h3>
              <h5 className="me-1 me-xs-2 message-support-header d-block d-md-none">
                ارسال پیام به پشتیبانی
              </h5>
            </div>
            <input
              id="title"
              className="message-support-input w-100 mt-3"
              style={{ height: "50px" }}
              placeholder="موضوع پیام"
            />
            <input
              id="content"
              className="message-support-input w-100 mt-3 text-wrap text-break"
              style={{ height: "100px", borderRadius: "40px" }}
              placeholder="متن پیام"
            />
            <div className=" request-Previous-btn-box m-auto mt-3">
              <button
                className="btn request-Previous-btn"
                type="button"
                onClick={() => {
                  sendMessage();
                }}
              >
                ارسال پیام
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpertSupport;
